module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_500_fnsa.d27d07f2.png";